import { useEffect, useState } from "react";
import api from "../lib/api";
import { Wallet, ArrowUp, ArrowDown } from "lucide-react";

export default function Credits() {
  const [data, setData] = useState({ balance: 0, history: [] });

  useEffect(() => {
    api.get("/buyer/credits").then(r => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="credits-page">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="label-eyebrow">Store Credits</p>
          <h1 className="font-editorial text-5xl sm:text-6xl tracking-editorial mt-3">Your balance</h1>
          <div className="mt-10 border border-[#1A1A1A]/10 bg-white p-10">
            <div className="flex items-center gap-3 text-[#8A8A8A] text-xs uppercase tracking-[0.25em]">
              <Wallet className="w-4 h-4 text-[#C9A968]" strokeWidth={1.5} /> Current Balance
            </div>
            <p className="font-editorial text-6xl mt-4 text-[#1E2C5A]" data-testid="credits-balance">₹{data.balance.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            <p className="text-xs text-[#8A8A8A] mt-4 leading-relaxed">
              Credits are managed by the TileRoom team and applied at checkout.
              For any questions about your balance, please reach TILAKRAJ at +91 95432 17216.
            </p>
          </div>
          <div className="mt-6 border-l-2 border-[#C9A968] bg-[#F7F5EE] p-6" data-testid="credits-referral-message">
            <p className="label-eyebrow !text-[#1E2C5A] mb-2">A Note From Us</p>
            <p className="font-editorial text-xl leading-snug text-[#1A1A1A] italic">
              &ldquo;Credits are for life. Whenever your referee purchases from us we give credits to you — that&apos;s our way of telling a thank you.&rdquo;
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="label-eyebrow mb-4">Statement</p>
          {data.history.length === 0 ? (
            <p className="text-[#8A8A8A]" data-testid="credits-empty">No credit activity yet.</p>
          ) : (
            <ul className="divide-y divide-[#1A1A1A]/10" data-testid="credits-history">
              {data.history.map((t, i) => (
                <li key={t.id || i} className="py-4 flex items-center justify-between gap-4">
                  <div className="flex items-start gap-4">
                    <div className={`w-9 h-9 flex items-center justify-center ${t.delta >= 0 ? "bg-[#1E2C5A] text-[#C9A968]" : "bg-red-900/10 text-red-700"}`}>
                      {t.delta >= 0 ? <ArrowUp className="w-4 h-4" strokeWidth={1.5} /> : <ArrowDown className="w-4 h-4" strokeWidth={1.5} />}
                    </div>
                    <div>
                      <p className="text-sm">
                        <span className={t.delta >= 0 ? "text-[#1E2C5A] font-medium" : "text-red-700 font-medium"}>
                          {t.delta >= 0 ? "+" : ""}₹{Math.abs(t.delta).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                        <span className="text-[#8A8A8A]"> · balance ₹{t.balance_after.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </p>
                      {t.reason && <p className="text-xs text-[#5C5C5C] mt-1 italic">&ldquo;{t.reason}&rdquo;</p>}
                    </div>
                  </div>
                  <p className="text-xs text-[#8A8A8A]">{new Date(t.created_at).toLocaleDateString()}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
